import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { CorrispondenzaArrivoDTO } from "@app/shared/dto/gescor/corrispondenza-arrivoDTO";
import { MapperDocumento } from "../mapper-documento";
import { CorrispondenzaArrivoVO } from "@app/shared/vo/gescor/corrispondenza-arrivoVO";
import { MapperClassificaGescor } from "./mapper-classifica-gescor";
import { MapperDocumentoGescor } from "./mapper-documento-gescor";
import { MapperMetaDatiProtocolloGescor } from "./mapper-metadati-protocollo-gescor";

@Injectable({
  providedIn: "root"
})
export class MapperCorrispondenzaArrivo
  implements MapperInterface<CorrispondenzaArrivoDTO, CorrispondenzaArrivoVO> {
  constructor(
    private documentoMapper: MapperDocumentoGescor,
    private mapperMetaDatiProtocolloGescor: MapperMetaDatiProtocolloGescor,
    private classificaGescorMapper: MapperClassificaGescor
  ) {}

  convertVoToDto(vo: CorrispondenzaArrivoVO): CorrispondenzaArrivoDTO {
    if (vo != null) {
      const dto = new CorrispondenzaArrivoDTO();
      dto.oggetto = vo.oggetto;
      dto.riservata = vo.riservata;
      dto.primario = this.documentoMapper.convertVoToDto(vo.primario);
      dto.allegati = this.documentoMapper.convertListVoToDto(vo.allegati);
      dto.metadatiProtocollo = this.mapperMetaDatiProtocolloGescor.convertVoToDto(vo.metadatiProtocollo);
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: CorrispondenzaArrivoDTO): CorrispondenzaArrivoVO {
    if (dto != null) {
      const vo = new CorrispondenzaArrivoVO();
      vo.oggetto = dto.oggetto;
      vo.classifica = this.classificaGescorMapper.convertListDtoToVo(dto.classifica);
      vo.primario = this.documentoMapper.convertDtoToVo(dto.primario);
      vo.allegati = this.documentoMapper.convertListDtoToVo(dto.allegati);
      vo.riservata = dto.riservata;
      vo.metadatiProtocollo = this.mapperMetaDatiProtocolloGescor.convertDtoToVo(dto.metadatiProtocollo);
      return vo;
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(
    voList: CorrispondenzaArrivoVO[]
  ): CorrispondenzaArrivoDTO[] {
    if (voList != null) {
      return voList.map(vo => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(
    dtoList: CorrispondenzaArrivoDTO[]
  ): CorrispondenzaArrivoVO[] {
    if (dtoList != null) {
      return dtoList.map(dto => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
